/**
* @Author: Roxy Chen
* @Date:   2016-08-17T18:10:52+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-22T19:43:21+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import React, { Component , PropTypes } from "react";
import { Waypoint } from "react-waypoint";

import { Link } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/global";

import { Navigator , MobileNav } from "./nav";
import AnimateEffect from "../../tool/animateEffect";
import { IndexFooter } from "./../index/indexFooter.js"

import { SupportedBrandSection } from "./supportedBrandSection"

import { StringHelper, _ } from '../../strings'
import  LanguageBar from '../LanguageBar';

export default class SupportedBrands extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceWaypoint: false,
      landingWaypoint: false,
      navFix: true
    };
  }
  componentDidMount(){}

  onLanguageChange(newLanguage) {
    console.log("newLanguage: ", newLanguage);
    this.forceUpdate();
  }

  render() {
    const {
      serviceWaypoint,
      landingWaypoint,
      navFix
    } = this.state;

    const familyAsystData = [
      {model: "AiPlug", type: "Smart Socket", remarks: ""},
      {model: "AiPlug 2", type: "Smart Socket", remarks: ""},
      {model: "AiStrip 2", type: "Smart Extention Cord", remarks: ""},
      {model: "AiGuard", type: "Smart Roller Shutter Controller", remarks: ""},
      {model: "Opure A8", type: "Smart Air Purifier", remarks: ""},
      {model: "AiStove", type: "Smart Gas Stove Controller", remarks: "Not launched yet."},
    ];
    const sampoData = [
      {model: "", type: "Smart Air-conditioner", remarks: ""},
      {model: "A11", type: "Smart Socket", remarks: ""},
      {model: "SMG-02", type: "Reed Switch", remarks: ""},
      {model: "SPM05", type: "Smart Motion Sensor", remarks: ""},
      {model: "sg_02_iaq", type: "Smart Air Sensor", remarks: ""},
      {model: "sth03", type: "Smart Temperature-humidity Sensor", remarks: ""},
      {model: "ZL-A19", type: "Smart Light Bulb", remarks: ""},
      {model: "APK-AB18C", type: "Smart Air Purifier", remarks: ""},
    ];
    const tecoData = [//Need further info: model
      {model: "", type: "Smart Air-conditioner", remarks: ""},
      {model: "", type: "Smart Exhaust Fans", remarks: ""},
      {model: "", type: "Smart Air Sensor", remarks: ""},
    ];
    const bintronicData = [
      {model: "BT-MVB", type: "Automatic Blinds", remarks: ""}
    ];
    const sapidoData = [
      {model: "WSG70N", type: "Smart Socket", remarks: ""},
      {model: "WDG71n", type: "Smart Sensor", remarks: ""},
    ];
    const edimaxData = [
      {model: "SP1101W", type: "Smart Socket", remarks: ""}
    ];
    const dlinkData = [
      {model: "DSP-W215", type: "Smart Socket", remarks: ""}
    ];
    const kakunData = [
      {model: "SmartPlug", type: "Smart Socket", remarks: ""}
    ];
    const areawellData = [
      {model: "AW2401", type: "Smart Extension Cord", remarks: ""}
    ];
    const belkinData = [
      {model: "Wemo Light Switch", type: "Smart Power Switch", remarks: ""}
    ];
    const philipsData = [
      {model: "Hue", type: "Smart Light Bulb", remarks: ""}
    ];
    const quirkData = [
      {model: "Spotter", type: "Smart Sensor", remarks: ""}
    ];
    const withingsData = [
      {model: "WS-50", type: "Body Scale", remarks: ""}
    ];
    const broadLinkData = [
      {model: "RM2", type: "IR Blaster", remarks: ""}
    ];
    const irKitData = [
      {model: "IRKit", type: "IR Blaster", remarks: "Opensource infrared remote controller."}
    ];
    const qnapData = [
      {model: "NAS", type: "NAS", remarks: ""}
    ];
    // const smartSocketData = [
    //   {brand: "FamilyAsyst", model: "AiPlug", remarks: ""}, {brand: "Edimax", model: "SP1101W", remarks: ""},
    //   {brand: "Sapido", model: "WSG70N", remarks: ""}, {brand: "D-link", model: "DSP-W2155", remarks: ""},
    //   {brand: "Kakun", model: "SmartPlug", remarks: ""},
    // ];
    // const smartExtensionCord = [
    //   {brand: "Areawell", "model": "AW2401", "remarks": ""},
    // ]
    // const powerSwitch = [
    //   {brand: "Belkin", model: "Wemo Light Switch", remarks:""}
    // ]
    // const smartBulb = [
    //   {brand: "Philips", model: "Hue", remarks:""}
    // ]
    // const smartSensor = [
    //   {brand: "Sapido", model: "WDG71n", remarks: ""},
    // ]
    // const irController = [
    //   {brand: "BroadLink", model: "RM2", remarks: "Need to fetch encrypted code"},
    //   {brand: "IRKit", model: "IRKit", remarks: "Opensource infrared remote controller"},
    // ]
    // const bodyScale = [
    //   {brand: "Withings", model: "WS-50", remarks: ""},
    // ]
    // const nas = [
    //   {brand: "QNAP", model: "NAS", remarks: "for lan bridge"},
    // ]

    const supportedBrandsList = [
      {title: "FamilyAsyst", data: familyAsystData},
      {title: "Sampo", data: sampoData},
      {title: "TECO", data: tecoData},
      {title: "Bintronic", data: bintronicData},
      {title: "Sampo", data: sapidoData},
      {title: "Edimax", data: edimaxData},
      {title: "D-link", data: dlinkData},
      {title: "Kakun", data: kakunData},
      {title: "Areawell", data: areawellData},
      {title: "Belkin", data: belkinData},
      {title: "Philips", data: philipsData},
      {title: "Quirk", data: quirkData},
      {title: "Withings", data: withingsData},
      {title: "BroadLink", data: broadLinkData},
      {title: "IRKit", data: irKitData},
      {title: "QNAP", data: qnapData},
      // {title: "Smart Extension Cord", data: smartExtensionCord}, {title: "Power Switch", data: powerSwitch},
      // {title: "Smart Bulb", data: smartBulb}, {title: "Smart Sensor", data: smartSensor},
      // {title: "Body Scale", data: bodyScale}, {title: "NAS", data: nas},
    ]

    const supportedBrandsListComponent = supportedBrandsList.map((it) => (<SupportedBrandSection title={it.title} data={it.data} />) )
    supportedBrandsListComponent.splice(1, 0, <Waypoint onEnter={()=>navFix&&this.setState({navFix: false})} />);
    return (
      <div className="main-container supportedBrandsPage">
        <Navigator onTop={navFix}/>
        <MobileNav />
        <section className="section-1 vertical-flex-item">
          <Waypoint onEnter={()=>!landingWaypoint&&this.setState({landingWaypoint: true})} />
            <div className="landing-container">
              <AnimateEffect trigger={landingWaypoint} className={"title"} effect={"fadeIn"} delay={1000} >{_("supported_brands_title")}</AnimateEffect>
            </div>
          <Waypoint onEnter={()=>{!navFix&&this.setState({navFix: true})}} />
        </section>
        <Waypoint onEnter={()=>!serviceWaypoint&&this.setState({serviceWaypoint: true})} />
        {/*<Waypoint onEnter={()=>navFix&&this.setState({navFix: false})} />*/}
        {supportedBrandsListComponent}
        {console.log(supportedBrandsListComponent)}
        <section className="section-4 vertical-flex-item">
        </section>
        <IndexFooter/>
        <LanguageBar onChange={(lang) => this.onLanguageChange(lang)}/>
      </div>
    );

  }
}


// export default connect((state , ownProps ) => ( state ))( Index );
